<template>
  <div id="app">
      <HomeHeader :isgzh="true"></HomeHeader>
    <div class="body_bg gzhbody_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="side_container">
                  <div class="title_all" style=" margin-bottom: 0;">
                    <div class="title_left">过刊目录</div>
                    <div class="clearfix"></div>
                  </div>
                  <dlistnumList :isgzh="true"></dlistnumList>
                </div>
              </div>
            </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import dlistnumList from '../components/dlistnumList'
import HomeHeader from '@/components/MasterTop'
  export default {
    data() {
      return {
      }
    },
    components: {
      dlistnumList,
      HomeHeader
    },
    methods: {
      onSubmit() {
      }
    }
  }
</script>

<style scoped>

</style>
